/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=c49d124c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/header-i18n/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c49d124c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c49d124c', __exports__)) {
    console.log('reload')
    api.reload('c49d124c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c49d124c", () => {
    console.log('re-render')
    api.rerender('c49d124c', render)
  })

}


export default __exports__